<template>
    <div class="input-row">
        <div class="row-input-item left">
            <label class="row-input-field-label" for="username">Username</label>
            <input type="text" name="username" class="row-input-field" :class="errorFieldClass" v-model="userAccount.username">
        </div>
        <div class="row-input-item middle">
            <label class="row-input-field-label" for="password">New Password</label>
            <input type="password" name="password" class="row-input-field" :class="errorFieldClass" v-model="newPassword">
        </div>
        <div v-if="windowWidth > 811" class="row-input-item right">
            <button class="button is-success full-mobile-width mobile-height save-button" @click="saveUserInformation">Save</button>
            <button class="button is-danger full-mobile-width mobile-height" @click="emitDeleteUserAccount">Delete</button>
        </div>
        <div class="row-input-item right">
            <label class="row-input-field-label" for="isPasswordSaved">Password Saved</label>
            <input type="checkbox" name="isPasswordSaved" class="row-input-field" :class="errorFieldClass" v-model="userAccount.isPasswordSaved" :readonly="true" @click.prevent>
        </div>
        <div class="row-input-item middle">
            <label class="row-input-field-label" for="createdBy">CreatedBy</label>
            <input @input.prevent name="createdBy" class="row-input-field" readonly v-model="userAccount.adminAccountUsername">
        </div>
        <div v-if="windowWidth <= 811" class="row-input-item right">
            <button class="button is-success full-mobile-width mobile-height save-button" @click="saveUserInformation">Save</button>
            <button class="button is-danger full-mobile-width mobile-height" @click="emitDeleteUserAccount">Delete</button>
        </div>
    </div>    
</template>

<script>
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'


import { mapGetters } from 'vuex'
import { mapState, mapMutations } from 'vuex'


export default {
    name: 'userAccountRow',

    props: ['userAccount', 'userIndex', 'windowWidth'],

    data(){
        return{
            newPassword: null,
            hasErrors: false,
        }
    },

    computed:{
        ...mapState([
            'userInfo'
        ]),

        errorFieldClass: function(){
            if(this.hasErrors == true){
                return "row-input-field-error"
            }
            else{
                return null
            }
        }

    },

    methods:{
        saveUserInformation: async function(){
            this.hasErrors = false;

            if(this.userAccount.username == null || this.userAccount.username == '' || this.newPassword == null || this.newPassword == ''){
                this.hasErrors = true;
                this.$snotify.error( "Please make sure all information is filled in." , "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: 4000,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    );
                    return
            }

            var params = `{
                "id": "${this.userAccount.id}", 
                "accountID": "${this.userInfo.accountID}",
                "username": "${this.userAccount.username}",
                "newPassword": "${this.newPassword}",
                "adminAccount": "${this.userInfo.userID}"
            }`

            try{
                const result = await sharedAPI.runScript("User- Save User Account Information", params);
				if(result.messages[0].code != 0){
					throw result.messages[0];
				}
                var scriptResult = JSON.parse(result.response.scriptResult);
                console.log(scriptResult)
                var errorCode = scriptResult.messages.code;
                var username = scriptResult.result.data.username; 
                var userID = scriptResult.result.data.userID;
                var adminAccount = scriptResult.result.data.adminAccount;
                var isPasswordSaved = scriptResult.result.data.isPasswordSaved;



                if(errorCode != 0){
                    throw scriptResult.messages;
                }

                this.userAccount.username = username;
                this.userAccount.id = userID;
                this.userAccount.adminAccount = adminAccount;
                this.userAccount.isPasswordSaved = isPasswordSaved;

                this.$snotify.success(`User account saved successfully`, "Success",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                );

                this.$emit('load-data')
            }
            catch(e){
				console.log(e)
                this.hasErrors = true;
                if(e.message){
                    this.$snotify.error(e.message, "Error",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                    )
                }
                else if(e.response.messages[0].message != undefined){
                    this.$snotify.error(e.message[0].message, "Error",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                    )
                }
                else{
                    this.$snotify.error("Could not create the admin account.", "Error",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                    )
                }
            }

        },


        emitDeleteUserAccount: async function(){
            this.$emit('emitDeleteUserAccount', this.userIndex, this.userAccount.id);    
        }
    },

    returnFalse: function(){
        return false
    }


    
}
</script>

<style scoped>

.input-row{
    width: 100%;
    vertical-align: middle;
    border-bottom: 1px solid #DBDBDB
}

.row-input-field{
    width: 75%;
    border: 1px solid #363636;
    border-radius: 5px;
    font-size: 1em;
    line-height: 1.5;
}

.row-input-field-label{
    display: none;
}

.row-input-field-error{
    border: 1px solid #E53E3E;
}

.row-input-item{
    display: inline-block;
    padding: 8px 0px 8px 12px;
}

.left{
    width: 28%;
}

.middle{
    width: 28%;
}

.first-middle{
    width: 35%
}

.right{
    width: 8%;
}

.save-button{
    margin-right: 3px
}


@media screen and (max-width: 811px){
    .row-input-field-label{
        display: inline-block;
        padding-right: 6px;
        font-weight: 600;
        width: 50%
    }

    .row-input-field{
        width: 50%;
        border: 1px solid #363636;
        border-radius: 5px;
        font-size: 1em;
    }

    .row-input-item{
        display: block;
    }

    .full-mobile-width{
        width: 100%;
    }

    .mobile-height{
        height: 44px;
    }
    
    .left{
        width: 100%;
    }

    .first-middle{
        width: 100%;
    }

    .middle{
        width: 100%;
    }

    .right{
        width: 100%;
    }

    .save-button{
        margin-right: 0px;
    }
}
</style>